import { randomUUID } from '@/shared/utils/id';
import Image from 'next/image';

const ReviewStars = (size: number) => {
  const stars = [];
  for (let i = 0; i < size; i++) {
    stars.push(
      <Image
        key={randomUUID()}
        className="review-item-star-icon"
        src="/svg/rating-star.svg"
        width={24}
        height={24}
        alt="rating-star-icon"
      />,
    );
  }
  return stars;
};

export default ReviewStars;
